import React from 'react';

/**
 * Keeps a render failure inside the current page so navigation remains usable.
 * Changing routes resets the boundary automatically.
 */
export default class PageErrorBoundary extends React.Component {
	state = { hasError: false };

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		console.error('Page render failed', error, errorInfo);
	}

	componentDidUpdate(previousProps) {
		if (this.state.hasError && previousProps.resetKey !== this.props.resetKey) {
			this.setState({ hasError: false });
		}
	}

	render() {
		if (!this.state.hasError) return this.props.children;

		return (
			<div className="container py-5 text-center" role="alert">
				<h2>We couldn&apos;t display this page</h2>
				<p className="mb-4">Your data is safe. You can retry this page or continue elsewhere without refreshing.</p>
				<div className="d-flex justify-content-center gap-2">
					<button className="btn btn-primary" type="button" onClick={() => this.setState({ hasError: false })}>
						Try again
					</button>
					<button className="btn btn-outline-secondary" type="button" onClick={this.props.onLeave}>
						Go to clients
					</button>
				</div>
			</div>
		);
	}
}
